import React from "react";
import moment from "moment";
import { useDCContext } from "@src/context";
import { SIGNOL_STAGE } from "@src/constants/constants";
import { AppUtils } from "@src/utils";
import { useOperatorContext } from "@src/context/operatorContext";
import { Divider, Loader, TextLink } from "@src/components/atoms";
import OverviewHeader from "@src/components/layout/OverviewHeader";
import ErrorPage from "@src/components/layout/ErrorPage";
import { default as OverviewGoals } from "./Goals";
import { default as RecentActivity } from "./RecentActivity";
import { default as AllTimeHighlights } from "./AllTimeHighlights";
import { default as QuickAnswers } from "./QuickAnswers";

const OverviewPage = () => {
  const { profile, greeting, commitment, latestEvent } = useOperatorContext();

  if (profile?.customer == null) {
    return <ErrorPage pageName={"overview"} />;
  }

  const { customer, operator } = profile;
  let lastReceived = !!operator?.lastEventDate
    ? moment.utc(operator.lastEventDate).format("MMM Do")
    : moment.utc().subtract(customer.reportingDelay, "days").format("MMM Do");

  if (SIGNOL_STAGE == "demo" && latestEvent?.ocurrenceDatetime) {
    lastReceived = moment(latestEvent.ocurrenceDatetime).format("MMM Do");
  }

  const dataDelayMessage = `Latest data we received for you: ${lastReceived}`;

  return (
    <section id={"target-display"} className="">
      <OverviewHeader
        customerCode={customer.customerCode}
        greeting={greeting}
        industry={customer.industry}
      />
      <OverviewGoals dataDelayMessage={dataDelayMessage} />
      <Divider />
      {/* Bottom section with cards */}
      <div className="mx-2 sm:mx-6 mb-2 sm:mb-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <RecentActivity />
          <AllTimeHighlights />
          <QuickAnswers onboardingDate={commitment?.modifiedAt} />
        </div>
      </div>
    </section>
  );
};

export default OverviewPage;
